import React from 'react';

export const ButtonGroup: React.FC = ({children}) => {
  return (
    <div className="flex gap-0 items-center [&>button:not(:first-child)]:rounded-l-none [&>button:not(:last-child)]:rounded-r-none [&>button:not(:first-child)]:border-l-0 [&>button:not(:last-child)]:border-r-0">
      {children}
    </div>
  );
};
